import { Autocomplete, Box, CircularProgress, Grid, InputLabel, TextField, Typography } from "@mui/material"
import style from "./style"
import React, { useState } from "react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LoadingButton } from "@mui/lab"
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CustomInput from "../../../../../components/CustomInput"

const UpdateSpecialPricePage = ({itemList,handleItemList,loading}) => {
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [saleName, setSaleName] = useState()
  const [product, setProduct] = useState([
    { product_name: "", selling_price: "", special_price: "", stock: "",discount:"" },
  ]);

  const handleAddField = () => {
    setProduct([
      ...product,
      {  product_name: "", selling_price: "", special_price: "", stock: "",discount:""  },
    ]);
    handleItemList();
  };

  const handleProduct = (value, index, key) => {
    const updatedProductDetails = [...product];
    const item = updatedProductDetails[index];

    if (
      (key === "sellingprice" || key === "specialPrice" || key === "discount" || key === "stock") &&
    Number(value) < 0
    ) {
      return;
    }

    if (key === "name") {
      const selectedItem = itemList.find((item) => item.title === value);
      if (selectedItem) {
        item.product_name = selectedItem.title;
        item.selling_price = selectedItem.sellingPrice || "";
        item.special_price = "";
        item.discount = "";
      }
    } else if (key === "specialPrice") {
      const special = parseFloat(value);
      const selling = parseFloat(item.selling_price);

      if (!isNaN(selling) && !isNaN(special)) {
        if (special >= selling) {
          return;
        }
        item.special_price = value;
        item.discount = (((selling - special) / selling) * 100).toFixed(2);
      } else {
        item.special_price = value;
        item.discount = "";
      }
    } else if (key === "discount") {
      const discount = parseFloat(value);
      const selling = parseFloat(item.selling_price);

      if (discount >= 100) {
        return;
      }

      item.discount = value;

      if (!isNaN(selling) && !isNaN(discount)) {
        const calculatedSpecial = selling * (1 - discount / 100);
        item.special_price = calculatedSpecial.toFixed(2);
      } else {
        item.special_price = "";
      }
    } else {
      item[key] = value;
    }

    setProduct(updatedProductDetails);
  };

  const handleDeleteField = (index) => {
    const updatedProductInformation = [...product];
    updatedProductInformation.splice(index, 1);
    setProduct(updatedProductInformation);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  }

  return(
    <Box px="5px" pt="20px">
      <form 
        onSubmit={(e) => handleSubmit(e)}
      >
        <Typography sx={style.heading}>Update Special Price</Typography>
        <Box>
          <Grid container>
            <Grid item xs={12} sx={{...style.card,overflowY:"scroll",maxHeight:"500px"}}>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <Typography sx={style.label}>Sale Name<span style={{ color: "red" }}>*</span></Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    placeholder="Enter Sale Name"
                    id="saleName"
                    error={""}
                    name="saleName"
                    value={saleName}
                    onChange={(event,newValue) =>{
                      const trimmedValue = newValue.replace(/^\s+/, ""); 
                      if (trimmedValue.length <= 25) {
                        setSaleName(trimmedValue);
                      }
                    }
                    }
                    autoComplete="saleName" 
                  />
                </Box>

                <Box sx={style.inputBox}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <InputLabel sx={style.label}>Start Date<span style={{ color: "red" }}>*</span></InputLabel>
                    <DatePicker sx={style.dateInput}
                      value={startDate}
                      onChange={(newValue) => {setStartDate(newValue);}}
                      maxDate={endDate}
                      slotProps={{
                        field: {
                          readOnly: true
                        }
                      }} />
                  </LocalizationProvider> 
                </Box>              
                
                <Box sx={style.inputBox}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <InputLabel sx={style.label}>End Date<span style={{ color: "red" }}>*</span></InputLabel>
                    <DatePicker sx={style.dateInput}
                      value={endDate}
                      onChange={(newValue) => {setEndDate(newValue);}}
                      minDate={startDate}
                      slotProps={{
                        field: {
                          readOnly: true
                        }
                      }} />
                  </LocalizationProvider> 
                </Box>
              </Box>
              <Grid item xs={12} lg={12} sx={{...style.gridbox}}>
                <Typography sx={style.gridText}>Product Info</Typography>

                {product.map((item, index) => (
                  <Box sx={{...style.leaveSection,width:"100%"}} key={index}>
                    <Grid container sx={style.itemGrid}>
                      <Grid item xs={1} lg={0.1}>
                        <Typography>{index + 1}</Typography>
                      </Grid>
                      <Grid item xs={12} lg={2.5}>
                        <Autocomplete
                          id="autocomplete"
                          options={itemList || []}
                          getOptionLabel={(option) => option?.title}
                          onInputChange={(event, newInputValue) => {
                            handleItemList(newInputValue);
                          }}
                          onChange={(event, newValue) => {
                            handleProduct(newValue?.title, index, "name");
                          }}
                          renderInput={(params) => (
                            <>
                              <TextField
                                placeholder="product"
                                {...params}
                                sx={{ ...style.modalInput,
                                  ...style.inputSpace,
                                }}
                                // label="Search Employee"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {loading ? (
                                        <CircularProgress
                                          color="inherit"
                                          size={20}
                                        />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            </>
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} lg={2}>
                        <CustomInput
                          variant="outlined"
                          required
                          fullWidth
                          id="sellingPrice"
                          placeholder="Selling Price"
                          defaultValue={product[index]?.selling_price}
                          readOnly
                          error={""}
                          name="sellingPrice"
                          value={product[index]?.selling_price}
                          onChange={(e, val) => handleProduct(val, index, "sellingPrice")}
                          // onFocus={handleFocus}
                          autoComplete="sellingPrice"
                        />
                      </Grid>
                      <Grid item xs={12} lg={2}>
                        <CustomInput
                          variant="outlined"
                          required
                          id="specialPrice"
                          placeholder="Special Price"
                          error={""}
                          name="specialPrice"
                          defaultValue={product[index]?.special_price}
                          type="number"
                          value={product[index]?.special_price?.toString()}
                          onChange={(e, val) => handleProduct(val, index, "specialPrice")}
                          // onFocus={handleFocus}
                          autoComplete="specialPrice"
                        />
                      </Grid>
                      <Grid item xs={12} lg={2}>
                        <CustomInput
                          variant="outlined"
                          required
                          id="discount"
                          placeholder="Discount(%)"
                          error={""}
                          name="discount"
                          defaultValue={product[index]?.discount}
                          type="number"
                          value={product[index]?.discount?.toString()}
                          onChange={(e, val) => handleProduct(val, index, "discount")}
                          // onFocus={handleFocus}
                          autoComplete="discount"
                        />
                      </Grid>
                      <Grid item xs={12} lg={2}>
                        <CustomInput
                          variant="outlined"
                          required
                          id="stock"
                          placeholder="Stock"
                          error={""}
                          defaultValue={product[index]?.stock}
                          name="stock"
                          type="number"
                          value={product[index]?.stock?.toString()}
                          onChange={(e, val) =>
                            handleProduct(val, index, "stock")
                          }
                          // onFocus={handleFocus}
                          autoComplete="stock"
                        />
                      </Grid>
                      
                      {index === 0 && (
                        <Grid item xs={1.5} lg={0.5}>
                          <Box sx={style.addIcon} onClick={handleAddField}>
                                    +
                          </Box>
                        </Grid>
                      )}
            
                      {index !== 0 && (
                        <Grid item xs={1.5} lg={0.5}>
                          <Box
                            sx={style.deleteIcon}
                            onClick={() => handleDeleteField(index)}
                          >
                            <DeleteOutlineIcon />
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                ))}
              </Grid>
            </Grid>
            
            
          </Grid>
          <Box px={2}>
            <LoadingButton
            //   loading={loading}
              variant="contained"
              sx={style.jobButtons}
              type="submit"
              disabled={!startDate || 
                        ! endDate ||
                        !saleName ||
                        product.some((p) => 
                          !p.product_name ||
                          !p.discount ||
                          !p.selling_price ||
                          !p.stock ||
                          !p.special_price
                        ) }
            >
              {"Save Price"}
            </LoadingButton>
          </Box>
        </Box>
      </form>
    </Box>
  )
}

export default UpdateSpecialPricePage